import React from 'react';
import PropTypes from 'prop-types';
import { useLabels } from '../../../hooks/useLabels';

/** Errors and warnings listed by original Excel row number. */
export default function ImportIssues({ errors, warnings }) {
	const { t } = useLabels();
	if (errors.length === 0 && warnings.length === 0) return null;
	const items = [
		...errors.map((e) => ({ ...e, tone: 'danger' })),
		...warnings.map((w) => ({ ...w, tone: 'warn' })),
	].sort((a, b) => a.rowNumber - b.rowNumber);
	return (
		<div className='tw:max-h-[360px] tw:overflow-y-auto tw:rounded-panel tw:border tw:border-border tw:bg-surface'>
			<ul className='tw:m-0 tw:list-none tw:p-0'>
				{items.map((item, i) => (
					<li
						key={`${item.rowNumber}-${item.tone}-${i}`}
						className='tw:flex tw:gap-3 tw:border-b tw:border-border tw:px-4 tw:py-2 tw:text-[13px] tw:last:border-b-0'
					>
						<span className='tw:w-[70px] tw:shrink-0 tw:font-mono tw:text-ink-3'>
							{t('import.row')} {item.rowNumber}
						</span>
						<span className={item.tone === 'danger' ? 'tw:text-danger' : 'tw:text-warn'}>{item.message}</span>
					</li>
				))}
			</ul>
		</div>
	);
}

ImportIssues.propTypes = {
	errors: PropTypes.arrayOf(PropTypes.shape({ rowNumber: PropTypes.number, message: PropTypes.string })).isRequired,
	warnings: PropTypes.arrayOf(PropTypes.shape({ rowNumber: PropTypes.number, message: PropTypes.string })).isRequired,
};
